<template>
  <el-dialog title="输入作业内容" :visible.sync="localVisible" :close-on-click-modal="false" class="mobile-homework-content-dialog" @close="handleClose" @opened="handleOpened">
    <el-input
      placeholder="请输入作业内容"
      v-model="localContent"
      ref="homeworkContentInput"
      style="width: 100%;"
      :maxlength="200"
      @keyup.enter.native="handleEnterKey">
    </el-input>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取 消</el-button>
      <el-button type="primary" @click="handleConfirm">保 存</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'MobileHomeworkContentDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    content: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      localContent: '',
      originalContent: ''
    };
  },
  computed: {
    // 创建一个计算属性来管理visible状态
    localVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit('update:visible', value);
      }
    }
  },
  watch: {
    content: {
      handler(newVal) {
        this.localContent = newVal;
        this.originalContent = newVal;
      },
      immediate: true
    },
    visible(newVal) {
      if (newVal) {
        // 弹窗打开时重置内容为传入的content
        this.localContent = this.content;
        this.originalContent = this.content;
      }
    },
    localContent(newVal) {
      this.$emit('update:content', newVal);
    }
  },
  methods: {
    handleClose() {
      this.localContent = this.originalContent;
      this.$emit('close');
    },
    handleOpened() {
      this.$emit('opened');
      this.$nextTick(() => {
        this.focusInput();
      });
    },
    
    focusInput() {
      if (this.$refs.homeworkContentInput) {
        this.$refs.homeworkContentInput.focus();
      }
    },
    handleEnterKey(event) {
      event.preventDefault();
      this.handleConfirm();
    },
    handleCancel() {
      this.localContent = this.originalContent;
      this.$emit('close');
    },
    handleConfirm() {
      console.log('handleConfirm called, localContent:', this.localContent);
      this.originalContent = this.localContent;
      this.$emit('save', this.localContent);
    }
  }
};
</script>

<style>
/* 移动端作业内容弹窗样式 */
.mobile-homework-content-dialog .el-dialog {
  width: 90%;
  max-width: 500px;
}

/* 输入框样式优化 */
.el-dialog .el-input__inner {
  -webkit-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
  user-select: text;
}

.el-dialog .el-textarea__inner {
  -webkit-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
  user-select: text;
}
</style>